import { cx } from '@mage-ui/styled-system/css';
import {
  button,
  columnCard,
  text,
  title as titleRecipe,
} from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { useState } from 'react';
import { isExternalLink } from 'utils/isExternalLink';
import { ImageRound } from '../../images/image-round/ImageRound';
import { RoundPlaceholder } from '../../images/round-placeholder/RoundPlaceholder';

// CardItem & RoundCarouselItem
export const ColumnCardBase = ({
  src,
  title,
  altImg,
  description,
  ctaText,
  ctaSlug,
  className,
  ...props
}) => {
  const [show, setShow] = useState(true);

  if (!show) {
    return null;
  }

  const isExternal = isExternalLink(ctaSlug);

  return (
    <div
      className={cx(columnCard().root, className?.root ?? className?.root)}
      {...props}
    >
      <div className={columnCard().imageWrapper}>
        {src !== undefined ? (
          <ImageRound
            src={src}
            alt={altImg ?? title}
            sizes={{ width: 185, height: 185 }}
            className={columnCard().image}
            onError={() => setShow(false)}
          />
        ) : (
          <RoundPlaceholder texts={{ a11yText: title }} />
        )}
      </div>

      <div className={columnCard().contentWrapper}>
        <h3
          className={cx(
            titleRecipe({ size: '5', weight: 'bold' }),
            columnCard().title,
          )}
        >
          {title}
        </h3>
        {description && (
          <div
            className={cx(text({ size: '3' }), columnCard().description)}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>
      {ctaSlug && (
        <Link
          className={cx(
            button(),
            columnCard().ctaText,
            className?.cta ?? className?.cta,
          )}
          href={ctaSlug ?? '#'}
          {...(isExternal && {
            target: '_blank',
            rel: 'noopener noreferrer',
          })}
        >
          {ctaText && ctaText}
        </Link>
      )}
    </div>
  );
};
